import _         from 'lodash';
import BigNumber from 'bignumber.js';
import Model     from 'alto-orm/lib/orm/model';

export class BillHeader extends Model {
  static nominativeName = 'hlavička účtu';
  static accusativeName = 'hlavičku účtu';
};

export class BillItem extends Model {
  static nominativeName  = 'položka účtu';
  static accusativeName  = 'položku účtu';
  static attrNameMapping = {
    headerID:  'header',
    productID: 'product'
  };

  static deserialize(row) {
    const item = super.deserialize(row);

    item.mnozstvi  = new BigNumber(row.mnozstvi);
    item.prachy    = new BigNumber(row.prachy);
    item.prachyPuv = new BigNumber(row.prachyPuv);
    item.dan       = new BigNumber(row.dan);
    item.danSazba  = new BigNumber(row.danSazba);

    return item;
  }

  static serialize(item) {
    const row = super.serialize(item);

    row.mnozstvi  = item.mnozstvi.toString();
    row.prachy    = item.prachy.toString();
    row.prachyPuv = item.prachyPuv.toString();
    row.dan       = item.dan.toString();
    row.danSazba  = item.danSazba.toString();

    return row;
  }
};

export class BillPayment extends Model {
  static nominativeName  = 'platba účtu';
  static accusativeName  = 'platbu účtu';
  static attrNameMapping = {headerID: 'header'};
};
